"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useWindowLocation = function () {
    var _a = (0, react_1.useState)(window.location.pathname), currentPath = _a[0], setCurrentPath = _a[1];
    var windowLocationRef = (0, react_1.useRef)({
        current_path: currentPath,
        previous_path: '',
    });
    var navigate = function (link) {
        var linkLowerCase = link.toLowerCase();
        window.history.pushState({}, '', linkLowerCase);
        var navEvent = new PopStateEvent('popstate');
        window.dispatchEvent(navEvent);
    };
    var onLocationChange = function () {
        setCurrentPath(window.location.pathname);
        windowLocationRef.current.current_path = window.location.pathname;
        windowLocationRef.current.previous_path = currentPath;
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener('popstate', onLocationChange);
        return function () {
            window.removeEventListener('popstate', onLocationChange);
        };
    }, []);
    return { currentPath: currentPath, navigate: navigate, windowLocationRef: windowLocationRef };
};
exports.default = useWindowLocation;
//# sourceMappingURL=useWindowLocation.js.map